import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { GridColDef } from '@mui/x-data-grid-pro';
import { ReactElement, ReactNode } from 'react';
import { DataGridFiltersIndicator } from 'components/common/dataGridFiltersIndicator';
import { DataGridColumnSettingsButton } from './DataGridColumnSettingsButton';

interface DataGridToolbarActionsProps {
  excludeField?: GridColDef['field'];
  columnsDataQa?: string;
  afterColumns?: ReactNode;
  sx?: SxProps<Theme>;
}

const toolbarActionsSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
} satisfies SxProps<Theme>;

export function DataGridToolbarActions({
  excludeField,
  columnsDataQa,
  afterColumns,
  sx,
}: DataGridToolbarActionsProps): ReactElement {
  return (
    <Box sx={[toolbarActionsSx, ...(Array.isArray(sx) ? sx : [sx])]}>
      <DataGridColumnSettingsButton dataQa={columnsDataQa} />
      {afterColumns}
      <DataGridFiltersIndicator excludeField={excludeField} />
    </Box>
  );
}
